import { useEffect, useState } from "react";

function normalizeUrl(raw) {
  if (!raw) return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";
  if (!/^https?:\/\//i.test(trimmed)) return `https://${trimmed}`;
  return trimmed;
}

export default function ShoppingPanel({
  socket,
  room,
  isHost,
  chatMessages,
  showInput = true,
  onSubmitLink,
  tutorialStep = 0,
  onTutorialLinkInput,
  onTutorialLinkSet,
}) {
  const [shopUrlInput, setShopUrlInput] = useState("");

  useEffect(() => {
    if (!isHost) return;
    const msgs = Array.isArray(chatMessages) ? chatMessages : [];
    if (!msgs.length) return;
  }, [chatMessages, isHost]);

  const shareShoppingLink = () => {
    if (!isHost) return;

    const normalized = normalizeUrl(shopUrlInput);
    if (!normalized) return;

    if (typeof onTutorialLinkSet === "function") {
      onTutorialLinkSet();
    }

    if (typeof onSubmitLink === "function") {
      onSubmitLink(normalized);
      setShopUrlInput("");
      return;
    }

    socket.emit("chat-message", { room, text: `🛒 ${normalized}` });
    setShopUrlInput("");
  };

    return (
    <div className="shoppingPanelFlat">
      {showInput && isHost ? (
        <div className="shoppingControls">
          <div className={`tutorial-ring ${tutorialStep === 4 ? "is-active" : ""}`}>
            <input
              className="input"
              placeholder="Paste a link (video or shopping)"
              value={shopUrlInput}
              onChange={(e) => {
                const value = e.target.value;
                setShopUrlInput(value);

                if (typeof onTutorialLinkInput === "function") {
                  onTutorialLinkInput(value);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") shareShoppingLink();
              }}
            />
          </div>

          <div
            className={`tutorial-ring tutorial-ring-inline ${
              tutorialStep === 5 ? "is-active" : ""
            }`}
            style={{
              display: "flex",
              alignItems: "stretch",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={shareShoppingLink}
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              Set Link
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}